































import OverviewFlushCache from "@/components/OverviewFlushCache.vue";
import DonutChart from "@/components/DonutChart.vue";
import HeadingButtons from "@/components/HeadingButtons.vue";
import { Stats } from "@/types/stats";
import { bytesToSize } from "@/utils/conversion";
import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({
  components: {
    OverviewFlushCache,
    DonutChart,
    HeadingButtons,
  },
})
export default class OverviewStorage extends Vue {
  @State(state => state.stats.stats) stats!: Stats;

  get memoryUsed() {
    return bytesToSize(this.stats.bytes);
  }

  get totalMemory() {
    return bytesToSize(this.stats.limit_maxbytes);
  }

  get donutChartValues() {
    const used = this.stats.bytes;
    const total = this.stats.limit_maxbytes;

    return [
      { label: "used", value: used },
      { label: "available", value: total - used },
    ];
  }
}
